/**
 * @generated SignedSource<<ef0f1710f27f304aeac97f6bd508c839>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeeSheetMultipleBookingToggleFragment_Facility$data = {
  readonly multipleBookingsEnabled: boolean;
  readonly " $fragmentType": "TeeSheetMultipleBookingToggleFragment_Facility";
};
export type TeeSheetMultipleBookingToggleFragment_Facility$key = {
  readonly " $data"?: TeeSheetMultipleBookingToggleFragment_Facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeeSheetMultipleBookingToggleFragment_Facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeeSheetMultipleBookingToggleFragment_Facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "multipleBookingsEnabled",
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "0b346dde969be93dc76c11a3719fe857";

export default node;
